// extracted by mini-css-extract-plugin
export default {"secondary-header":"SecondaryHeader_secondary-header__qYYv8","back-button":"SecondaryHeader_back-button__QVMCQ","header-title":"SecondaryHeader_header-title__sLMun"};